import React from "react";
import { Output } from "../../Text";
import {
  Button,
  ContentSection,
  PageWrap,
  ButtonContainer,
  Layout,
  Paragraph,
} from "@vwfs-bronson/bronson-react";
import { IconSize } from "../Icon";
import { Analytics } from "../../services/analytics";
import { trackInteractionSuccess } from "../../pages/page.utils";
import { isVtiBOP } from '../../common/JourneyType';

const BoniRefused = ({ redirectUrl, originSystem }) => {
  const [remainingSeconds, setRemainingSeconds] = React.useState(60);
  const pageName = "Credit check failed";

  const defaultTrackingData = {
    [Analytics.keys.pageName()]: pageName,
    [Analytics.keys.viewChange()]: pageName,
  };

  const trackPage = () => {
    setTimeout(() => {
      const pageData = {
        [Analytics.keys.eventType(0)]: "pageView",
        [Analytics.keys.eventAction(0)]: "Success",
        [Analytics.keys.eventType(1)]: "FinanceApproval",
        [Analytics.keys.eventAction(1)]: "Failed",
        [Analytics.keys.eventType(2)]: "Product journey",
        [Analytics.keys.eventAction(2)]: "End",
      };
      Analytics.setTrackingData({ ...defaultTrackingData, ...pageData });
      Analytics.trackPage();
    }, 1000);
  };
  const trackButton = () => {
    trackInteractionSuccess("Back to Heycar", defaultTrackingData);
  };

  React.useEffect(() => {
    trackPage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  React.useEffect(() => {
    window.setTimeout(() => {
      if (remainingSeconds > 0) {
        setRemainingSeconds(remainingSeconds - 1);
      } else {
        window.location.href = redirectUrl;
      }
    }, 1000);
  }, [remainingSeconds, redirectUrl]);
  const handleClick = () => {
    trackButton();
    window.location.href = redirectUrl;
  };
  const renderContent = () => {
    return (
      <>
        <Paragraph className="u-mt-large">
          {Output.resolve("pages.boniRefused.text")}
        </Paragraph>
        <Layout className="u-mt-large">
          <Layout.Item default="1/3" className="u-text-right u-pr">
            <i
              className={`c-icon  c-icon--[semantic-mail]  c-icon--${IconSize.XxLarge} u-mt`}
            ></i>
          </Layout.Item>
          <Layout.Item default="2/3">
            <Paragraph>
              <span>
                <strong>
                  {Output.resolve("pages.boniRefused.email.title")}
                </strong>
              </span>
            </Paragraph>
            <Paragraph>
              <span>{Output.resolve("pages.boniRefused.email.text")}</span>
            </Paragraph>
            <Paragraph>
              <Button
                element="a"
                link
                href={`mailto:${Output.resolve(isVtiBOP(originSystem)
                  ? "pages.boniRefused.vti.email.address"
                  : "pages.boniRefused.email.address"
                )}`}
                target="_blank"
              >
                {Output.resolve(isVtiBOP(originSystem)
                  ? "pages.boniRefused.vti.email.address"
                  : "pages.boniRefused.email.address")}
              </Button>
            </Paragraph>
          </Layout.Item>
        </Layout>
        <ButtonContainer center className="u-mt-xlarge">
          <Button className="appFixedButton" onClick={handleClick}>
            {Output.resolve(isVtiBOP(originSystem)
              ? "pages.boniRefused.vti.button"
              : "pages.boniRefused.button")}
          </Button>
        </ButtonContainer>
        <Paragraph className="u-text-center u-mt">
          {`${Output.resolve(
            "pages.boniRefused.redirectText.1"
          )}${remainingSeconds}${Output.resolve(
            "pages.boniRefused.redirectText.2"
          )}`}
        </Paragraph>
      </>
    );
  };

  return (
    <>
      <ContentSection pale>
        <PageWrap>
          <div className="u-text-center">
            <h3>{Output.resolveAsMarkdown("pages.boniRefused.title")}</h3>
          </div>
          {renderContent()}
        </PageWrap>
      </ContentSection>
    </>
  );
};

export default BoniRefused;
